import { type ReactionUser } from "./ReactionUser";

export const ENSURE_BUTTON_HEIGHT = {
	// Ensures button is h-6, 24px. xxs avatars do not quite fit into xs button, so we need negative
	// margins.
	xs: "-m-0.5",
	// Button already h-8, 32px.
	sm: "",
	// Ensures button is h-10, 40px.
	md: "m-0.5",
	// Ensures button is h-12, 48px.
	lg: "m-0.5",
} as const;

export const avatarGroupWidth = (reactions: ReactionUser[]) => {
	if (reactions.length === 1) {
		// 1 xxs avatar is 20px.
		return "w-5";
	} else if (reactions.length > 1) {
		// 2 xxs avatars are 40px with -ml-1, or 4px.
		return "w-9";
	}

	return "";
};

/**
 * Moves both the avatar and its white border in from the left on reaction. This CSS MUST be applied
 * using :first-child, or the border stays stationary, and the avatar moves into it. This is because
 * the border is actually a separate div that wraps the avatar.
 */
export const slideFirstUserInOnReaction = (currentUserReacted: boolean) => ({
	"[&>:first-child]:-ml-4 [&>:first-child]:opacity-0 [&>:first-child]:duration-0 [&>:first-child]:transition-all":
		!currentUserReacted,
	"[&>:first-child]:ml-0 [&>:first-child]:mr-0 [&>:first-child]:opacity-100 [&>:first-child]:duration-500 [&>:first-child]:transition-all":
		currentUserReacted,
});

export const positionOverflowAvatarsAbsoluteRight0 = (overflowReactions: ReactionUser[]) => [
	"relative",
	{ "[&>:last-child]:absolute [&>:last-child]:right-0": overflowReactions.length > 1 },
];
